<template>
  <div class="yqqj-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="状态">
              <el-select v-model="searchForm.mark" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="未全检" :value="0" />
                <el-option label="全检中" :value="1" />
                <el-option label="全检完成" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="150"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.product_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客户名称"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="色板来源"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.color_source}}</span>
<!--                      <span v-if="scope.row.color_source===0">厂部标准色板</span>-->
<!--                      <span style="color:#F56C6C" v-if="scope.row.color_source===1">客户提供色板</span>-->
<!--                      <span style="color:#F56C6C" v-if="scope.row.color_source===2">厂部定制色板</span>-->
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="工厂"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.factory_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客户地址"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="排产时间"
                    width="180"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.schedule_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="色板信息"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.swatch}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="班组"
                    width="130"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.paintteam!==null&&scope.row.paintteam!==''&&scope.row.paintteam!==undefined">{{scope.row.paintteam}}</span>
                      <span v-if="scope.row.paintteam===null||scope.row.paintteam===''||scope.row.paintteam===undefined" style="color:#999">未填</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="全检状态"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.paintmark===0" type="danger">未全检</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.paintmark===1" type="warning">全检中</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.paintmark===2">已完成</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="油漆全检详情"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules" v-loading="getLoading" label-position="right" label-width="90px" size="small">
        <el-card style="margin-bottom: 20px">
          <el-table
            size="small"
            stripe
            :data="detailTableData"
            style="width: 100%">
            <el-table-column
              v-for="item in detailTableColumn"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              align="center">
              <template slot-scope="scope">
                <i v-if="scope.row[item.prop]===0" style="color:#E6A23C" class="el-icon-time"></i>
                <i v-if="scope.row[item.prop]===1" style="color:#67C23A" class="el-icon-success"></i>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 16px;font-size: 12px;padding-left: 6px">
            <span style="color:#99a9bf">色板信息：</span>
            <span>{{editForm.swatch}}</span>
          </div>
        </el-card>
        <el-form-item label="生产订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="油漆班组" prop="paintteam">
          <el-input v-model="editForm.paintteam" maxlength="10" :disabled="editForm.paintmark===2"></el-input>
        </el-form-item>
        <el-form-item label="生产工序" prop="process" v-if="editForm.paintmark!==2">
          <el-checkbox-group v-model="editForm.process">
            <el-checkbox v-for="item in processInfo" :label="item.val" :checked="item.isdis" :disabled="item.isdis">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" v-if="editForm.paintmark!==2" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">{{editForm.paintmark!==2?'取消':'关闭'}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { paintAllCheckList, getPaintCheckDetail, submitPaintCheck, exportPaintAllCheckList } from '@/api/erp'

export default {
  name: 'yqqj',
  computed: {
    user: getUser
  },
  data() {
    return {
      exportLoading: false,
      searchForm: {
        search: '',
        mark: null,
        type: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      getLoading: false,
      editVisible: false,
      editloading: false,
      processInfo: [],
      detailTableColumn: [],
      detailTableData: [],
      editForm: {
        orderid: '',
        ordername: '',
        process: [],
        paintmark: 0,
        swatch: '',
        paintteam: ''
      },
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        paintteam: [{ required: true, message: '请输入油漆班组', trigger: 'blur' }],
        group: [{ required: true, message: '请选择木工分组', trigger: 'blur' }],
        process: [{ required: true, message: '请选择生产工序', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        const data = {
          groupid: this.user.dGroupid,
          mark: this.searchForm.mark,
          content: this.searchForm.search,
          userid: this.user.dUserid,
          role: this.user.role,
          type: this.searchForm.type,
          tableName: '油漆全检'
        }
        exportPaintAllCheckList(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        groupid: this.user.dGroupid,
        mark: this.searchForm.mark,
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        role: this.user.role,
        type: this.searchForm.type
      }
      paintAllCheckList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.editForm.orderid = row.order_id
      this.editForm.ordername = row.order_num + ' / ' + row.product_num + ' / ' + row.address
      this.editForm.paintmark = row.paintmark
      this.editForm.swatch = row.swatch
      this.editForm.paintteam = row.paintteam
      this.editForm.group = []
      this.editForm.process = []
      this.getLoading = true
      this.processInfo = []
      this.editVisible = true
      getPaintCheckDetail({ orderid: this.editForm.orderid }).then(response => {
        let processArr = []
        let column = []
        let d = {}
        for (let p of response.data.processesList) {
          processArr.push({ name: p.dName, val: p.dSpid, isdis: p.is_complet })
          let width = 80
          if (p.dName.length > 4) {
            width = 130
          }
          column.push({ prop: 'gx' + p.dSpid, label: p.dName, width: width })
          d[`gx${p.dSpid}`] = p.is_complet
        }
        let tableData = []
        tableData.push(d)
        this.detailTableColumn = column
        this.processInfo = processArr
        this.detailTableData = tableData
        this.getLoading = false
      }).catch(() => {
        this.getLoading = false
      })
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.editForm.orderid,
              jsonStr: this.editForm.process.join(','),
              paintteam: this.editForm.paintteam
            }
            submitPaintCheck(data).then(response => {
              this.$message({
                message: '油漆全检提交成功',
                type: 'success'
              })
              this.editloading = false
              this.editVisible = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.yqqj-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
